import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const cache = {};

export const useCmsContent = (pageKey) => {
  const [content, setContent] = useState(cache[pageKey] || {});
  const [loading, setLoading] = useState(!cache[pageKey]);

  useEffect(() => {
    if (cache[pageKey]) {
      setContent(cache[pageKey]);
      setLoading(false);
      return;
    }
    let cancelled = false;
    axios.get(`${API}/api/cms/${pageKey}`)
      .then(res => {
        if (!cancelled) {
          const sections = res.data?.sections || {};
          cache[pageKey] = sections;
          setContent(sections);
        }
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [pageKey]);

  const t = (key, fallback = '') => content[key] || fallback;

  return { content, loading, t };
};
